import programs from './loyalty/programs'
import tiers from './loyalty/tiers'
import rewards from './loyalty/rewards'
import customer from './loyalty/customer'
import rules from './loyalty/rules'

// Export as nested Vuex modules
// This allows access via loyalty/programs/actionName
// The parent module acts as a container for nested modules
export default {
  namespaced: true,
  modules: {
    programs,
    tiers,
    rewards,
    customer,
    rules
  }
}
